import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import { getAdditionalServiceName } from '../../utils/additionalServices';

import roleConfig from '../../configs/roles';

import style from '../common/orders/ordersStyle.module.css'

import moment, { Moment } from 'moment';

const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '20px',
      marginBottom: '20px',
    },
    wrapperinner : {
      width: '23%',
      '&:last-child':{
        width: 'calc( 25% - 0px )',
      }
    },
    '@media print':{
      wrapperinner : {
        boxShadow: 'none',
        width: '22% !important',
        marginRight: '2%',
        '&:last-child':{
          width: 'calc( 28% - 0px )',
          marginRight: '0px'
        }
      },
    }
  });

interface PaymentReportHeaderPrintProps {
  classes: any;
  userId: number;
  startDate: Moment;
  endDate: Moment;
  companyName: string | undefined;
  paymentType: string;
  selectedFeeType: Array<string>
};

const paymentReportHeaderPrint = (props: PaymentReportHeaderPrintProps) => {
  const startDate: string = moment(props.startDate).format('DD MMM YY');
  const endDate: string = moment(props.endDate).format('DD MMM YY');
  const companyNameTitle: string = props.userId === roleConfig.roleId.forwarderUser ? 'GHA' : 'Forwarder';

  return (
    <div className={ props.classes.wrapper}>
      <div className={ style.flex }>

        <div className={ `${ props.classes.wrapperinner } ${ style.wrapper }` }>
          <div className={ style.pot }> {companyNameTitle }:</div>
          <div className={ style.pod }>{ props.companyName ? props.companyName : 'All' }</div>
        </div>

        <div className={ `${ props.classes.wrapperinner } ${ style.wrapper }` }>
          <div className={ style.pot }> Start Date:</div>
          <div className={ style.pod }>{ startDate }</div>
        </div>

        <div className={ `${ props.classes.wrapperinner } ${ style.wrapper }` }>
          <div className={ style.pot }> End Date:</div>
          <div className={ style.pod }>{ endDate }</div>
        </div>

        <div className={ `${ props.classes.wrapperinner } ${ style.wrapper }` }>
          <div className={ style.pot }>Payment Type:</div>
          <div className={ style.pod }>{ props.paymentType }</div>
        </div>
  
      </div>

      {/* <div className={ style.wrapper}>
        <div className={ style.pot }>Fee Type:</div>
        { props.selectedFeeType.map((type: string, index: number) => (
          <span key={ index } className={ style.pod }>{ getAdditionalServiceName(type) }{ index !== props.selectedFeeType.length - 1? ',': '' } </span>
        ))}
      </div> */}

    </div>
  )
};

export default withStyles(styles)(paymentReportHeaderPrint);